import ChoicePicker from '../components/ChoicePicker';
import CheckboxConsentInput from '../components/CheckboxConsentInput';
import ContinueButtonBar from '../components/ContinueButtonBar';
import PdfPreviewActionButton from '../components/PdfPreviewActionButton';
import type { useCareerUpApplicationFlow } from './useCareerUpApplicationFlow';
import type { YesNo } from './careerUpApplicationTypes';

type Flow = ReturnType<typeof useCareerUpApplicationFlow>;

const YES_NO = (t: Flow['t']) => [
  { value: 'yes' as const, label: t('submitDocuments.careerUpApplication.yes') },
  { value: 'no' as const, label: t('submitDocuments.careerUpApplication.no') },
];

export interface CareerUpApplicationChatComposerProps {
  flow: Flow;
  onOpenConsentPdfRead?: () => Promise<void>;
}

export default function CareerUpApplicationChatComposer({
  flow,
  onOpenConsentPdfRead,
}: CareerUpApplicationChatComposerProps) {
  const {
    currentStep,
    t,
    values,
    advanceConfirmNoCard,
    advanceReadConsent,
    advanceAgree,
    agreeChecked,
    setAgreeChecked,
  } = flow;
  if (!currentStep) return null;

  if (currentStep.stepId === 'confirmNoCard') {
    const current =
      values.confirmNoCard === 'yes' || values.confirmNoCard === 'no' ? values.confirmNoCard : null;
    return (
      <div style={{ padding: '12px 16px' }}>
        <ChoicePicker
          value={current}
          options={YES_NO(t)}
          onChange={(v) => void advanceConfirmNoCard(v as YesNo)}
        />
      </div>
    );
  }

  if (currentStep.stepId === 'readConsentDocument') {
    return (
      <PdfPreviewActionButton
        label={t('submitDocuments.careerUpApplication.openConsentDocument')}
        onClick={() => {
          if (!onOpenConsentPdfRead) return;
          void (async () => {
            await onOpenConsentPdfRead();
            await advanceReadConsent();
          })();
        }}
      />
    );
  }

  if (currentStep.stepId === 'agreeApply') {
    return (
      <CheckboxConsentInput
        checked={agreeChecked}
        label={t('submitDocuments.careerUpApplication.agreeCheckbox')}
        onChange={setAgreeChecked}
        continueLabel={t('submitDocuments.chat.continue')}
        onContinue={() => void advanceAgree()}
      />
    );
  }

  return null;
}

export function CareerUpApplicationDeclinedComposer({ onContinue }: { onContinue: () => void }) {
  return <ContinueButtonBar onContinue={onContinue} />;
}
